import {ContentItem} from "@api";
import * as C from "@/components";
import {VimeoBackground} from "@/components/Video/VimeoBackground";
import css from './hero-section-with-video.module.scss';

interface HeroSectionWithVideoProps {
    pageContent: Record<string, ContentItem>;
    videoId: number;
    mobileVideoId: number;
    imageDirectory: string;
    isVideoUnlisted?: boolean;
    unlistedPrivacyHash?: string;
    mobileUnlistedPrivacyHash?: string;
    className?: string;
    textClassName?: string;
    thumbnailName?: string;
    mobileThumbnailName?: string;
}

export const HeroSectionWithVideo = (props: HeroSectionWithVideoProps) => {
    const { pageContent, videoId, mobileVideoId, imageDirectory, isVideoUnlisted = false, unlistedPrivacyHash = '', mobileUnlistedPrivacyHash = '', className = '', textClassName = '', thumbnailName = 'hero-thumbnail.jpg', mobileThumbnailName = 'hero-thumbnail.jpg' } = props;

    const getHeroText = () => {
        const heroSectionKeys = [
            "hero.eyebrow",
            "hero.headline",
            "hero.subhead",
            "hero.body",
            "hero.link",
        ];
        const usedSectionKeys = heroSectionKeys.filter((key) => pageContent[key]?.data !== undefined);
        const textElements = usedSectionKeys.map((key) => {
            switch (key) {
                case "hero.eyebrow":
                    return <C.PageContent {...pageContent[key]} className={css['eyebrow']} typography={C.Typography.H5} />
                case "hero.headline":
                    return <h1 className='md:text-6xl lg:text-7xl'>
                        {pageContent[key].data}</h1>
                case "hero.subhead":
                    return !!pageContent[key].type
                        ? <h5 className='font-semibold md:text-xl lg:text-2xl' dangerouslySetInnerHTML={{
                            __html: pageContent[key].data,
                        }}/>
                        : <h5 className='font-semibold md:text-xl lg:text-2xl'>
                            {pageContent[key].data}</h5>
                case "hero.body":
                    return <></>
                case "hero.link":
                    return <></>
            }
        });

        return (
            <>
                <div className={`block md:hidden text-new-black-domina text-center space-y-5 py-10 px-6 absolute w-full z-[21] top-0 left-1/2 -translate-x-1/2 ${textClassName}`}>
                    {...textElements}
                </div>
                <div className={`hidden md:block text-new-black-domina ${textClassName}`}>
                    <div className="
                        absolute z-[21] top-1/2 -translate-y-1/2 max-w-[500px]
                        md:translate-x-4 lg:translate-x-28 space-y-3
                    ">
                        {...textElements}
                    </div>
                </div>
            </>
        )
    };

    return (
        <C.PageSection variant={C.PageSectionVariant.Hero} className={className}>
            <C.Card className={`${css['card-height']} relative md:flex flex-col md:justify-center max-md:!rounded-none`}>
                {getHeroText()}
                <VimeoBackground
                    videoId={videoId}
                    imageDirectory={imageDirectory}
                    className='hidden md:block'
                    isVideoUnlisted={isVideoUnlisted}
                    unlistedPrivacyHash={unlistedPrivacyHash}
                    needsThumbnail
                    thumbnailName={thumbnailName}
                />
                <VimeoBackground
                    videoId={mobileVideoId}
                    imageDirectory={imageDirectory}
                    className='block md:hidden'
                    needsThumbnail
                    isVideoUnlisted={isVideoUnlisted}
                    unlistedPrivacyHash={mobileUnlistedPrivacyHash}
                    isMobile
                    thumbnailName={mobileThumbnailName}
                />
            </C.Card>
        </C.PageSection>
    );
}
